import React from "react";
import "./index.scss";
import { Box, Button, Grid2, Typography, useMediaQuery } from "@mui/material";
import useInfoContext from "hooks/useInfoContext";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const Invite = () => {
  const { userInfo } = useInfoContext();
  const isMobile = useMediaQuery("(max-width:900px)");
  const inviteLink = `https://onacademyon.com/login?r=${userInfo?.refId}`;

  const handleCopy = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(inviteLink);
    }
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          title: "آکادمی آن",
          text: "از طریق لینک زیر به آکادمی بیا و بعد از تکمیل ثبت نام آن کارتت رو بگیر",
          url: inviteLink,
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(inviteLink);
    }
  };
  return (
    <Box className="container-invite">
      <Grid2 container columns={12} className="invite-box">
        <Grid2 item size={{ xs: 10 }} className="invite-text">
          <Typography variant="h5" className="text">
            برای دعوت از دوستان خود به آکادمی آن لینک زیر را ارسال کنید.
          </Typography>
        </Grid2>
        <Grid2 item size={{ xs: 10 }} className="invite-link">
          <Typography
            variant="h6"
            sx={{ fontSize: `${isMobile ? "0.8rem" : "1.1rem"}` }}
          >
            {inviteLink}
          </Typography>
          <ContentCopyIcon onClick={handleCopy} sx={{cursor: 'pointer'}}/>
        </Grid2>
        <Grid2 item size={{ xs: 10 }} className="box-button-share">
          <Button
            variant="contained"
            onClick={handleShare}
            className="button-share"
          >
            اشتراک گذاری
          </Button>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default Invite;
